module.exports = __webpack_public_path__ + "static/media/a3_04.d5037e84.jpg";